import { createSelector } from 'reselect';

const getInsurance = (state = {}) => state.insurance || {};

export const getIsFetchingStatus = createSelector(
  [getInsurance],
  (insurance) => insurance.isFetching,
);

export const getIsErrorStatus = createSelector(
  [getInsurance],
  (insurance) => !!insurance.error,
);

export const getAbTestVar = createSelector(
  [getInsurance],
  (insurance) => insurance.abTestVar || 0,
);

export const getInsurancePolicies = createSelector(
  [getInsurance],
  (insurance) => insurance.policies || [],
);

export const getPresetUrl = createSelector(
  [getInsurance],
  (insurance) => insurance.presetUrl || '',
);

export const getTotalPricePolicies = createSelector(
  [getInsurancePolicies],
  (policies) => !!policies.length && policies.reduce((value, policy) => value + policy.subscriptionFee, 0),
);
